module.exports = __webpack_public_path__ + "img/35400.4d1ea49e.jpg";